<template>
  <div>
    <div v-if="isLoading"><generic-loading-skeleton /></div>
    <div v-else>
      <div class="pb-2"><h2>My content</h2></div>
      <div class="alert alert-error" v-if="isErrored">{{ errorMsg }}</div>
      <div v-else>
        <div v-if="myContent && myContent.length > 0">
          <div v-for="(content, i) in myContent" :key="i">
            <a
              class="d-flex pl-1"
              :href="content.url"
              :target="getLinkTarget(content)"
              @click="handleContentClick(content)"
            >
              <img
                v-if="content.imageUrl"
                class="content-image"
                :src="content.imageUrl"
              />
              <div class="content-title pb-16-px ml-2">{{ content.title }}</div>
            </a>
          </div>
        </div>
        <div v-else>No content to display</div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import { mapGetters } from "vuex";
import * as CONSTANTS from "@/store/constants";
import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";
import GenericLoadingSkeleton from "./GenericLoadingSkeleton";
export default {
  name: "my-content",
  mixins: [HomebaseMixpanelMixin],
  components: {
    GenericLoadingSkeleton,
  },
  data() {
    return {
      CONSTANTS,
      isLoading: false,
      isErrored: false,
      errorMsg: CONSTANTS.SERVER_ERROR_MESSAGE,
      myContent: [],
      defaultContent: [
        {
          title: "Recent cases",
          imageUrl: CONSTANTS.FALLBACK_ADSK_LOGO_IMG_URL,
          handleClick: () => {
            window.dispatchEvent(new CustomEvent('open-tickets-panel'));
          }
        }
      ],
      managerContent: [],
    };
  },
  created() {
    this.initializeContent();
  },
  computed: {
    ...mapGetters(["user"]),
  },
  methods: {
    async initializeContent() {
      this.isLoading = true;
      let myContent = [];
      try {
        let res = await api.getMyContent();
        let contentList = res.value;
        let thumbnailRequests = this.constructThumbnailRequests(contentList);
        let thumbnailRes = await api.batchGetDriveItemThumbnails(
          thumbnailRequests
        );
        myContent = this.formatMyContent(contentList, thumbnailRes);
      } catch (e) {
        // suppress error
      } finally {
        this.myContent = this.appendPersonalizedContent(myContent);
        this.isLoading = false;
      }
    },

    appendPersonalizedContent(myContent) {
      let res = myContent;
      res = res.concat(this.defaultContent);
      if (this.user.manager && this.managerContent.length > 0) res = res.concat(this.managerContent);
      return res;
    },

    constructThumbnailRequests(contentList) {
      if (!contentList || contentList.length == 0) return null;

      let requests = [];
      contentList.forEach((content) => {
        requests.push({
          id: content.id,
          method: "GET",
          url: this.constructThumbnailRequestUrl(content),
        });
      });

      return requests;
    },

    constructThumbnailRequestUrl(contentData) {
      // extract uuid from eTag
      let itemId = contentData.eTag.slice(1, -1).split(",")[0];
      let url = `sites/${SHAREPOINT_SITE_ID}/lists/${MY_CONTENT_LIST_ID}/items/${itemId}/driveItem/thumbnails?select=small`;
      return url;
    },

    formatMyContent(contentList, thumbnailRes) {
      let thumbnailMap = this.constructThumbnailMap(thumbnailRes);

      let myContent = contentList.map((content) => {
        return {
          title: content.fields.Hyperlink.Description,
          url: content.fields.Hyperlink.Url,
          imageUrl: thumbnailMap[content.id],
          newTab: content.fields.OpenInNewTab,
        };
      });

      return myContent;
    },

    constructThumbnailMap(thumbnailRes) {
      // construct map of id => imageUrl
      let map = {};
      thumbnailRes.responses.forEach((thumbnail) => {
        map[thumbnail.id] = thumbnail.body.value[0].small.url;
      });
      return map;
    },

    getLinkTarget(contentData) {
      return contentData.newTab ? "_blank" : "_self";
    },

    handleContentClick(contentData) {
      let subEvent = contentData.title;
      if (contentData.url) subEvent += ` - ${contentData.url}`;
      this.trackMyContentClicked(subEvent);

      if (contentData.handleClick) {
        contentData.handleClick();
      }
    },
  },
};
</script>

<style scoped>
a {
  color: black !important;
  text-decoration: none !important;
}
.panel-title-sm {
  padding-bottom: 20px;
}
.content-title:hover {
  cursor: pointer;
}
.content-image {
  width: 20px;
  max-width: 20px;
  max-height: 20px;
  object-fit: contain;
}
</style>